import request from "../api/agent";

export class SuperQaReportService {
  async getSuperQaReport({
    page,
    limit,
    partners,
    clients,
    facilities,
    user,
    filter_type,
    status,
    processed_date_range,
    start_time_range,
    end_time_range,
    export_type,
    header_names
  }) {
    const params = {
      page,
      limit,
      header_names: Array.isArray(header_names) ? header_names.join(",") : (header_names || ""),
      processed_date_range: processed_date_range || "",
      start_time_range: start_time_range || "",
      end_time_range: end_time_range || "",
      partners: Array.isArray(partners) ? partners.join(",") : (partners || ""),
      clients: Array.isArray(clients) ? clients.join(",") : (clients || ""),
      facilities: Array.isArray(facilities) ? facilities.join(",") : (facilities || ""),
      user: Array.isArray(user) ? user.join(",") : (user || ""),
      filter_type: Array.isArray(filter_type) ? filter_type.join(",") : (filter_type || ""),
      status: Array.isArray(status) ? status.join(",") : (status || ""),
      export: export_type ? "true" : "false",
    };

    const response = await request.get("reports/retireve-super-qa-report", { params });
    return response?.data ?? response?.response?.data;
  }
}
